export const getUserId = () => {
  const userInfo = localStorage.getItem('loginInfo.logged_user_data');
  if (userInfo && userInfo !== '') {
    try {
      return JSON.parse(userInfo).user_id;
    } catch (e) {
      return '';
    }
  }
  return '';
};
export const getUserIsKids = () => {
  const userInfo = localStorage.getItem('loginInfo.logged_user_data');
  if (userInfo && userInfo !== '') {
    try {
      return JSON.parse(userInfo).isKids === 'true';
    } catch (e) {
      return false;
    }
  }
  return false;
};
